// Contact.js
import React from 'react';
import { motion } from 'framer-motion';

const Contact = () => {
  return (
    <motion.section
      id="contact"
      className="py-20 bg-gray-50 dark:bg-gray-900"
      style={{ backgroundColor: 'var(--background-color-typeA' }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <div className="container mx-auto px-4 text-center">
        {/* Título */}
        <h3 className="text-3xl var[--primary-text-color] mb-2">Contacto</h3>
        <p className="var[--secondary-text-color] mb-12">
          Puedes contactarnos a través de los siguientes medios.
        </p>

        {/* Datos de contacto */}
        <div className="grid lg:px-[10%]  grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-1">
          {/* Teléfono */}
          <div className="flex items-center justify-center space-x-2">
            <i className="fas fa-phone-alt icon-style text-2xl"></i>
            <div>
              <h4 className="text-lg font-semibold ">Teléfono</h4>
              <p>
                <a href="tel:+5493498479604" className=" hover:underline hover:text-blue-500">
                  +549 3498 479604
                </a>
              </p>
            </div>
          </div>

          {/* Correo */}
          <div className="flex items-center justify-center space-x-2">
            <i className="fas fa-envelope icon-style text-2xl"></i>
            <div>
              <h4 className="text-lg font-semibold">Correo Electrónico</h4>
              <p>
                <a href="mailto:enerbyte.ing@gmail.com" className="hover:text-blue-500 hover:underline">
                  enerbyte.ing@gmail.com
                </a>
              </p>
            </div>
          </div>

          {/* Instagram */}
          <div className="flex items-center justify-center space-x-2">
            <i className="fab fa-instagram icon-style text-2xl"></i>
            <div>
              <h4 className="text-lg font-semibold">Instagram</h4>
              <p>
                <a
                  href="https://instagram.com/enerbyte.ing"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-blue-500 hover:underline"
                >
                  @enerbyte.ing
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default Contact;
